import { Card, CardContent } from "@/core/components/ui/card";
import { PackChatPanel } from "@/payroll/pack-chat/pack-chat-panel";
import { PayBreakdownPaneShell } from "./pay-breakdown-pane-shell";

interface PayBreakdownPackChatTabProps {
  businessId: string | null;
  periodStart: string | undefined;
  /** The run whose workbook this page is showing. */
  runId: string | null;
  isLocked?: boolean;
}

// Questions technicians raised about their packs, as its own tab.
//
// A thin wrapper, like PayBreakdownEmailsTab: the pane shell supplies the same
// gutters as the Grid and Roster tabs, and the card gives it the same frame, so
// switching tabs does not shift the page. The queue itself scrolls inside.
export const PayBreakdownPackChatTab = ({
  businessId,
  periodStart,
  runId,
  isLocked,
}: PayBreakdownPackChatTabProps) => (
  <PayBreakdownPaneShell fillHeight>
    {/* Sized to the screen, not to a fixed 34rem, so a tall monitor shows more of
        the conversation instead of more empty page. It has to be stated rather
        than inherited: the page's content sits inside a ScrollArea, so `flex-1`
        has nothing definite to resolve against and the card grows to its content.
        241px is the app nav (66) plus this section's header and tabs (143) plus
        the pane's own bottom padding (32) — measured, and 61px more than the
        `calc(100dvh-180px)` the Emails and Adjustments tabs use, which is why
        those two overshoot the fold. */}
    <Card className="flex h-[--pack-chat-panel-height] w-full min-w-0 flex-col overflow-hidden rounded-lg border-stroke-tertiary bg-surface-primary shadow-none [--pack-chat-panel-height:clamp(420px,calc(100dvh-241px),1200px)]">
      {/* No padding at all: every pane scrolls to the card's own edges and carries
          its inset inside its scrolled content. Padding out here left content
          vanishing into a blank band and pushed each scrollbar 20px in from the
          frame — the scroll read as broken rather than as scrolled. */}
      <CardContent className="min-h-0 flex-1 overflow-y-auto p-0">
        {/* Columns: technicians, their questions, the conversation, the pack. */}
        <PackChatPanel
          businessId={businessId}
          periodStart={periodStart}
          runId={runId}
          isLocked={isLocked}
        />
      </CardContent>
    </Card>
  </PayBreakdownPaneShell>
);
